@if (!company) {
  <div class="d-flex justify-content-center align-items-center h-100">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
}

<!-- Company box -->
@if (company) {
  <div>
    <!-- Box header -->
    <div class="d-flex justify-content-between mb-4 align-items-center">
      <!-- Box title -->
      <span class="text-primary fs-6 fw-bold mb-2">{{ 'MY_COMPANY' | translate }}</span>
      <!-- Company logo -->
      @if (company?.attributes?.logo?.data?.attributes?.url) {
        <img
          [src]="getFullImageUrl(company.attributes.logo.data.attributes.url)"
          [title]="company.attributes.logo.data.attributes.name"
          class="p-2 company-logo"
          loading="lazy"
          />
      }
    </div>
    <!-- Company name -->
    @if (company?.attributes?.name) {
      <div>
        <div class="fs-4">
          {{ company.attributes.name }}
        </div>
      </div>
    }
    <!-- Company managers -->
    @if (company?.attributes?.manager?.data?.length ?? 0 > 0) {
      <div>
        <div class="fw-bold mt-3 mb-4 fs-6">{{ 'EMPLOYEES' | translate }}</div>
        <div class="d-flex flex-column gap-2">
          @for (manager of company.attributes.manager.data; track manager) {
            <div>
              <div class="d-flex align-items-center gap-4 user-line">

                <!-- User initials + name -->
                <div class="d-flex align-items-center gap-4">
                  <div class="user-initials-circle-light text-truncate">
                    {{
                      manager.attributes.givenName[0].toUpperCase() +
                      manager.attributes.familyName[0].toUpperCase()
                    }}
                  </div>
                  <div class="user-name text-truncate">
                    {{ manager.attributes.givenName }} {{ manager.attributes.familyName }}
                  </div>
                </div>

                <!-- User email -->
                <a [href]="'mailto:' + manager.attributes.email" class="user-mail text-truncate">{{
                  manager.attributes.email
                }}</a>

              </div>
            </div>
          }
        </div>
      </div>
    }
    <!-- See company button -->
    <div class="d-flex mt-3">
      <button
        class="btn btn-primary rounded-5 ms-auto text-white btn-md flex align-items-center px-3"
        [routerLink]="['/company']"
        >
        <div style="display: flex; align-items: center; font-size: 14px; gap: 5px">
          <span>{{ 'VIEW_COMPANY' | translate }}</span>
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </button>
    </div>
  </div>
}
